import OpSdk, {MsService} from '@/sdk/OpSdk';
import Ajax from '../../../../bs/src/sdk/ajax/Ajax';

export enum ParagraphType {
    /**
     * 纯文本.
     */
    TEXT = 'TEXT',
    /**
     * 视频.
     */
    VIDEO = 'VIDEO',
    /**
     * 音频.
     */
    AUDIO = 'AUDIO',
    /**
     * 图片.
     */
    IMAGE = 'IMAGE',
    /**
     * markdown.
     */
    MARKDOWN = 'MARKDOWN',
    /**
     * 富文本.
     */
    RICHTEXT = 'RICHTEXT',
}

export interface DocParagraph {
    id: string;
    sectionId: string;
    type: ParagraphType;
    content?: string;
    mediaUrl?: string;
    seqNo: number;
    createAt: number;
    updateAt: number;
}

function getAjax(): Ajax {
    const sdk = OpSdk.getInstance();
    const ajax = sdk.getAjax(MsService.KK_HELP_DOC);
    return ajax;
}

const map: Map<string, DocParagraph[]> = new Map();


export async function listDocParagraph(sectionId: string): Promise<DocParagraph[]> {
    const existParagraphs = map.get(sectionId);
    if (existParagraphs) {
        return existParagraphs;
    }
    const paragraphs = await getAjax().post<DocParagraph[]>('/op/ud/doc/paragraph/list', {sectionId});
    map.set(sectionId, paragraphs);
    return paragraphs;
}
